<template>
    <div class="product-listing__container">
        <div class="preloader-container">
            <span class="loader"></span>
        </div>
    </div>
</template>
<script>
export default {};
</script>
<style lang="scss" scoped>
.preloader-container {
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;

    .loader {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        font-size: 50px;

        @include mq($lg) {
            left: 48%;
        }

        @include mq(640px) {
            left: 45%;
        }
    }
}

.product-listing__container {
    /* min-height: calc(100vh - 450px); */
    min-height: 50px;
    width: 100%;
    position: relative;
}
</style>
